import {Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'frog-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [RouterLink],
})
export class FooterComponent implements OnInit {
    public hosted = environment.hosted;

    constructor() {}

    ngOnInit(): void {}
}
